























import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
@Component({})
export default class ByMobile extends Vue {
  @Prop({ type: Array }) initData;
  @Prop({ type: String, required: true }) id;
  @Prop({ type: String }) label;
  @Prop({ type: Boolean, default: false }) required;
  @Prop({ type: Boolean, default: false }) disabled;
  @Inject() labelWidth;
  @Inject() master;
  tagList = [];
  nameFilter = "";
  total = 0;
  curPageNumber = 0;
  form = {
    tagSeleted: ""
  };
  get rules() {
    return this.required
      ? {
          tagSeleted: [
            {
              required: true,
              message: this.$t("Root.MemberPicker.required"),
              trigger: "blur"
            }
          ]
        }
      : {};
  }
  @Watch("initData", { immediate: true })
  watchInitData(data) {
    if (data) {
      this.form.tagSeleted = data.join(",");
    }
  }
  mounted() {
    this.registerSelf();
  }

  registerSelf() {
    const { label, id } = this;
    this.master.registerPlugin({
      label: label || id,
      id,
      validator: this.validator.bind(this)
    });
  }
  validator() {
    return new Promise((resolve, reject) => {
      let $form: any = this.$refs.form;
      $form.validate(valid => {
        if (valid) {
          resolve(this.form.tagSeleted.split(","));
        }
      });
    });
  }
}
